export class Preference {
	public static category = {
		cheques: 'CHEQUES',
		contact: 'CONTACT',
		modeReception: 'MODE_RECEPTION',
		notifications: 'NOTIFICATIONS',
		releveaffaires: 'RELEVEAFFAIRES'
	};

	public static cheques = {
		email1: { code: 'CHEQUES_EMAIL1', label: 'Email 1 CHEQUES', valeurOptional: true },
		email2: { code: 'CHEQUES_EMAIL2', label: 'Email 2 CHEQUES', valeurOptional: true },
		email3: { code: 'CHEQUES_EMAIL3', label: 'Email 3 CHEQUES', valeurOptional: true }
	};

	public static contact = {
		email: { code: 'CONTACT_EMAIL', label: 'EMAILPREFERENCE' },
		telephone: { code: 'CONTACT_TELEPHONE', label: 'TELEPHONEPREFERENCE' }
	};

	public static modeReception = {
		retour: { code: 'MODE_RECEPTION_RETOUR', label: 'Retour' }
	};

	public static notifications = {
		depots: { code: 'NOTIFICATIONS_DEPOTS', label: 'Dépôts' },
		ribsDelivres: { code: 'NOTIFICATIONS_RIBS_DELIVRES', label: 'RIB délivrés' },
		virementsCredites: { code: 'NOTIFICATIONS_VIREMENTS_CREDITES', label: 'Virements crédités' },
		reglementsCheques: { code: 'NOTIFICATIONS_REGLEMENTS_CHEQUES', label: 'Règlements par chèques' },
		reglementsVirements: { code: 'NOTIFICATIONS_REGLEMENTS_VIREMENTS', label: 'Règlements par virements' },
		operationsRenvoyesCarpa: {
			code: 'NOTIFICATIONS_OPERATIONS_RENVOYES_CARPA',
			label: 'Opérations renvoyées par la Carpa',
			valeurOptional: true
		},
		OppositionChequesEmis: {
			code: 'NOTIFICATIONS_OPPOSITION_CHEQUES_EMIS',
			label: 'Confirmation opposition sur chèque émis'
		},
		email1: { code: 'NOTIFICATIONS_EMAIL1', label: 'Email 1', valeurOptional: true },
		email2: { code: 'NOTIFICATIONS_EMAIL2', label: 'Email 2', valeurOptional: true },
		email3: { code: 'NOTIFICATIONS_EMAIL3', label: 'Email 3', valeurOptional: true }
	};

	public static releveaffaires = {
		email1: { code: 'RELEVEAFFAIRES_EMAIL1', label: 'Email 1 RELEVE AFFAIRES', valeurOptional: true },
		email2: { code: 'RELEVEAFFAIRES_EMAIL2', label: 'Email 2 RELEVE AFFAIRES', valeurOptional: true },
		email3: { code: 'RELEVEAFFAIRES_EMAIL3', label: 'Email 3 RELEVE AFFAIRES', valeurOptional: true },
		envoieAutomatique: { code: 'ENVOIEAUTOMATIQUE', label: 'ENVOIE AUTOMATIQUE', valeurOptional: true }
	};
}
